import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Grid} from '@material-ui/core'
import {isEmpty} from 'lodash'
import {getAntalNyaOrderByAfid,setofUpdatedashboardOrderTV} from 'actions'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({DashBoard,auth,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardOrderTY} = accountsData
    const { AntalNyaOrder,DashboardOrderFilterOption} = DashBoard;
    return {
        authUser,AntalNyaOrder,DashboardOrderFilterOption,updatedashboardOrderTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAntalNyaOrderByAfid: (Afid,userid,FilterOption) => dispatch(getAntalNyaOrderByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardOrderTV: () => dispatch(setofUpdatedashboardOrderTV()),
        dispatch
    };
}
class OrderNyaAntalLG extends Component {
    state={
        AntalNyaOrder:0,
        DashboardOrderFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getAntalNyaOrderByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
        .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                    this.setState({done: false})
                const Afid = this.props.Afid;
                
                this.props.getAntalNyaOrderByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
                .then(() => {
                    this.initiateInterval() 
                    this.setState({done: true})   
                })
            }
            },
            180000
        );           
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid
        if(parseInt(this.props.updatedashboardOrderTY) === 1){
            this.props.getAntalNyaOrderByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
            .then(() => {
                this.initiateInterval() 
                this.setState({done: true})   
            })
            this.props.setofUpdatedashboardOrderTV()
        }
        if(this.props.DashboardOrderFilterOption !== this.state.DashboardOrderFilterOption)
        {
            this.props.getAntalNyaOrderByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
            .then(() => {
                this.initiateInterval() 
                this.setState({done: true})   
            })
            this.setState({
                DashboardOrderFilterOption:this.props.DashboardOrderFilterOption 
            }) 
        }
    }
    render() {
        return (
            <div className="jr-card jr-card-full m-0">
                <div className="jr-fillchart-content">
                    <div className="text-center text-white">
                        <h2 style={{ paddingTop: '12px', margin: '0',fontSize:"1.5rem" }}><b><IntlMessages id="DashBoard.new.Orders"/></b></h2>
                    </div>
                    <div>
                        <Grid
                        container
                        direction="row"
                        >
                            <Grid item xs={12} className={"text-center"} style={{ marginTop: '-2rem' }}>
                            {
                                    this.state.done === false?
                                    <Skeleton variant="rectangular" height={40} width={150} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                                    :
                                    <>
                                <span style={{ fontSize: 160,color:"#fff", fontWeight: '500', color: '#44D1C2', '-webkit-text-stroke': '2px #54F3E3'}}>{this.formatNumber(this.props.AntalNyaOrder)}</span>
                                <span style={{ fontSize: 35,color:"#fff"}}>St</span>
                                </>
                            }
                            </Grid> 
                            <Grid item xs={12} className={"text-center"} style={{ marginTop: '-2rem' }}>
                            <span style={{ fontSize: 25,color:"#fff"}}>
                                <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="Month.Current"/></p>
                                </span>
                            </Grid>
                        </Grid>
                    </div>
                 </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(OrderNyaAntalLG);